import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PartImportCodesDataGrid } from "src/components/views/erp/warehouse/masterData/PartImportCodesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/partImportCodes")({
	staticData: { title: i18n.t("import_codes"), legacyViewKey: "partImportCodesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <PartImportCodesDataGrid />;
}
